export default {
    siteName: 'VR Lab',
    siteShort: 'VR Lab',
  };
